The job category information of the suggestion choice.

This will be a child job category suitable for posting a position profile.
